import { createAction } from 'redux-actions';

import * as actions from 'constants/templateList/TemplateListActions';
import coreActions from 'constants/actions';
import * as templateApi from 'api/templateList';

const { API } = coreActions;

export const navigateToTemplateEditor = createAction(
  actions.NAVIGATE_TO_TEMPLATE_EDITOR,
);

export const navigateToTemplateQuickView = createAction(
  actions.NAVIGATE_TO_TEMPLATE_QUICK_VIEW,
);

export const navigateToSurveyEditor = createAction(
  actions.NAVIGATE_TO_SURVEY_EDITOR,
  (id, shouldReplaceLocation) => ({ id, shouldReplaceLocation }),
);

export const templateListActionUse = createAction(
  actions.TEMPLATE_LIST_ACTION_USE,
);

export const templateListActionEdit = createAction(
  actions.TEMPLATE_LIST_ACTION_EDIT,
);

export const templateListActionDuplicate = createAction(
  actions.TEMPLATE_LIST_ACTION_DUPLICATE,
);

export const templateListActionOpenDeleteModal = createAction(
  actions.TEMPLATE_LIST_ACTION_OPEN_DELETE_MODAL,
);

export const mountTemplateList = createAction(
  actions.MOUNT_TEMPLATE_LIST,
  (listId, listInitialProps) => ({ listId, listInitialProps }),
);

export const useTemplate = createAction(
  actions.USE_TEMPLATE,
  (listId, itemId, options = { shouldReplaceLocation: false }) => ({
    listId,
    itemId,
    shouldReplaceLocation: options.shouldReplaceLocation,
  }),
);

export const templateListActionDelete = createAction(
  actions.TEMPLATE_LIST_ACTION_DELETE,
  (listId, itemIds) => ({ listId, itemIds }),
);

export const loadTemplateList = createAction(
  actions.LOAD_TEMPLATE_LIST,
  (listId, params) => ({ listId, params }),
);

export const toggleTemplateTileFavorite = createAction(
  actions.TOGGLE_TEMPLATE_TILE_FAVORITE,
  (listId, templateId, isFavorite) => ({ listId, templateId, isFavorite }),
);

export const templateTabChange = createAction(
  actions.TEMPLATE_TAB_CHANGE,
  (listId, tabName, page) => ({ listId, tabName, page }),
);

export const loadTemplateListPreviewOptions = createAction(
  actions.LOAD_TEMPLATE_LIST_PREVIEW_OPTIONS,
  (listId, text) => ({ listId, text }),
);

export const onTemplateSearch = createAction(
  actions.ON_TEMPLATE_SEARCH,
  (listId, text) => ({ listId, text }),
);

export const sortTemplateListColumn = createAction(
  actions.SORT_TEMPLATE_LIST_COLUMN,
  (listId, field, order) => ({ listId, field, order }),
);

export const postCreateTemplate = (...rest) => ({
  type: API,
  types: [
    actions.POST_CREATE_TEMPLATE_REQUEST,
    actions.POST_CREATE_TEMPLATE_SUCCESS,
    actions.POST_CREATE_TEMPLATE_FAILURE,
  ],
  api: templateApi.createTemplate,
  params: rest,
});

export const postDuplicateTemplate = (
  { listId, isCommon = false, shouldReplaceLocation },
  ...rest
) => ({
  type: API,
  types: [
    actions.POST_DUPLICATE_TEMPLATE_REQUEST,
    actions.POST_DUPLICATE_TEMPLATE_SUCCESS,
    actions.POST_DUPLICATE_TEMPLATE_FAILURE,
  ],
  api: templateApi.duplicateTemplate,
  params: rest,
  isCommon,
  listId,
  shouldReplaceLocation,
});

export const deleteTemplate = (listId, api, itemIds, ...rest) => ({
  type: API,
  types: [
    actions.DELETE_TEMPLATE_REQUEST,
    actions.DELETE_TEMPLATE_SUCCESS,
    actions.DELETE_TEMPLATE_FAILURE,
  ],
  api,
  params: rest,
  listId,
  itemIds,
});
